import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Lenis from "lenis";

export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
}

export const Reveal = ({ children, delay = 0, y = 40, className, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Marquee = ({ text }) => (
  <div className="marquee-wrap border-y border-white/10 py-6 overflow-hidden" dir="ltr" data-testid="editorial-marquee">
    <div className="marquee-track">
      {[0, 1].map((i) => (
        <span key={i} className="marquee-item font-serif text-2xl md:text-4xl text-ivory/40 italic">
          {text} <span className="text-gold not-italic mx-6">✦</span> {text} <span className="text-gold not-italic mx-6">✦</span>
        </span>
      ))}
    </div>
  </div>
);

export const Eyebrow = ({ children }) => (
  <p className="text-xs uppercase tracking-[0.3em] text-gold font-sans font-semibold mb-4">{children}</p>
);

export const GoldButton = ({ children, className = "", ...rest }) => (
  <button
    className={`inline-flex items-center justify-center gap-2 bg-gold text-black font-sans font-semibold text-sm tracking-wide px-8 py-4 hover:bg-goldlight transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    {...rest}
  >
    {children}
  </button>
);

export const OutlineButton = ({ children, className = "", ...rest }) => (
  <button
    className={`inline-flex items-center justify-center gap-2 border border-white/25 text-ivory font-sans text-sm tracking-wide px-8 py-4 hover:border-gold hover:text-gold transition-colors duration-300 disabled:opacity-50 ${className}`}
    {...rest}
  >
    {children}
  </button>
);
